// extracted by mini-css-extract-plugin
export default {"org-role-mapping":"tRdcwQlh6mCix8qLDUjf","org-role-mapping-row":"y7g5m_K35J9Q20l5dwt6","delete-action":"pk5JIhjL2v_WRzP2OUGC","arrow-icon":"i4djv3iN7azMdFaVKcAo"};